/* 🤖 this file was generated by svg-to-ts */
export const matIconSignalWifiStatusbarConnectedNoInternet4: {
  name: 'signal-wifi-statusbar-connected-no-internet-4';
  data: string;
} = {
  name: 'signal-wifi-statusbar-connected-no-internet-4',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M12 4C7.31 4 3.07 5.9 0 8.98L12 21l5-5.01V8h5.92C19.97 5.51 16.16 4 12 4zm7 14h2v2h-2z"/><path d="M19 10h2v6h-2z"/></svg>`
};
